import { Box, Button, Divider, Grid, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"

import { SpecialService } from "generated/graphql"

export type SpecialServiceType = {
  active: boolean
} & Pick<SpecialService, 'id' | 'name'>

interface ISpecialServiceProps {
  value: SpecialServiceType
  onAddClick: (id: number) => void
  onRemoveClick: (id: number) => void
}

const SpecialServiceItem = ({ value, onAddClick, onRemoveClick }: ISpecialServiceProps) => {

  // handlers
  const handleAddClick = () => {
    onAddClick(Number(value.id))
  }

  const handleRemoveClick = () => {
    onRemoveClick(Number(value.id))
  }

  return <Grid container item spacing={1} xs={12} sm={6} >
    <Box
      display='flex'
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      width='100%'
      borderBottom='1px solid'
      borderColor={grey[700]}
      padding={2}
    >
      {value.active ? (
        <Button onClick={handleRemoveClick} color='error' variant='contained'>
          Remove
        </Button>
      ) : (
        <Button variant='contained' onClick={handleAddClick} >
          Add
        </Button>
      )}
      <Typography variant='subtitle1'>
        {value.name}
      </Typography>
    </Box>
    <Divider orientation='horizontal' flexItem />
  </Grid>
}

export default SpecialServiceItem
